import { create } from "zustand";
import {
  ICompanyAccess,
  IObjectCompanies,
} from "../../../types/companyaccess.type";

type FilterMode = "all" | "uf" | "cities";

type CompanyStore = {
  company: ICompanyAccess | null;
  selectedCompanies: IObjectCompanies[];
  selectedUf: string | null;
  filterMode: FilterMode;
  actions: {
    toggleCompanySelection: (company: IObjectCompanies) => void;
    setUfSelection: (uf: string) => void;
    setAllSelection: () => void;
  };
};

const initialCompanies = (): IObjectCompanies[] => {
  const stored = localStorage.getItem("selectedCompanies");
  return stored ? JSON.parse(stored) : [];
};

const initialUf = (): string | null => {
  const stored = localStorage.getItem("selectedUf");
  return stored ? JSON.parse(stored) : null;
};

const initialFilterMode = (): FilterMode => {
  const stored = localStorage.getItem("filterMode") as FilterMode;
  return stored || "all";
};

const initialCompany = localStorage.getItem("selectedCompanies");

export const useCompanyStore = create<CompanyStore>((set) => ({
  company: initialCompany ? JSON.parse(initialCompany) : null,
  selectedCompanies: initialCompanies(),
  selectedUf: initialUf(),
  filterMode: initialFilterMode(),
  actions: {
    toggleCompanySelection: (company) =>
      set((state) => {
        const isAlreadySelected = state.selectedCompanies.some(
          (c) => c.companyId === company.companyId
        );

        let newSelectedCompanies: IObjectCompanies[];

        if (isAlreadySelected) {
          newSelectedCompanies = state.selectedCompanies.filter(
            (c) => c.companyId !== company.companyId
          );
        } else {
          newSelectedCompanies = [...state.selectedCompanies, company];
        }

        const newMode = newSelectedCompanies.length > 0 ? "cities" : "all";

        localStorage.setItem(
          "selectedCompanies",
          JSON.stringify(newSelectedCompanies)
        );
        localStorage.setItem("filterMode", newMode);
        localStorage.removeItem("selectedUf");

        return {
          selectedCompanies: newSelectedCompanies,
          selectedUf: null,
          filterMode: newMode,
        };
      }),

    setUfSelection: (uf) => {
      localStorage.setItem("selectedUf", JSON.stringify(uf));
      localStorage.setItem("filterMode", "uf");
      localStorage.removeItem("selectedCompanies");

      set({
        selectedCompanies: [],
        selectedUf: uf,
        filterMode: "uf",
      });
    },

    setAllSelection: () => {
      localStorage.setItem("filterMode", "all");
      localStorage.removeItem("selectedCompanies");
      localStorage.removeItem("selectedUf");

      set({
        selectedCompanies: [],
        selectedUf: null,
        filterMode: "all",
      });
    },
  },
}));

export const useCompanyStoreActions = () =>
  useCompanyStore((state) => state.actions);
